exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-beffe230]:hover {\n  cursor: pointer;\n}\n.main-menu[data-v-beffe230] {\n  padding-top: 15px;\n}\n.btn-full-width[data-v-beffe230] {\n  width: 100%;\n}\n.btn[data-v-beffe230] {\n  cursor: pointer;\n  border-radius: 0;\n}\n.menu-item[data-v-beffe230] {\n  margin-bottom: 15px;\n}\n.btn-first-line[data-v-beffe230] {\n  font-size: 10px;\n  line-height: 10px;\n  vertical-align: top;\n}\n.btn-primary-line[data-v-beffe230] {\n  font-size: 20px;\n  line-height: 26px;\n  vertical-align: top;\n}\n.btn-produced[data-v-beffe230] {\n  background-color: #ff8535;\n  color: #fff;\n}\n.btn-pick[data-v-beffe230] {\n  background-color: #28a745;\n  color: #fff;\n}\n.btn-item-info[data-v-beffe230],\n.btn-shipping-info[data-v-beffe230] {\n  background-color: #17a2b8;\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-beffe230","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MainMenu.vue
// module id = 1F9u
// module chunks = 1